<template>
  <ul :class="{ [type]: true }" role="group">
    <li
      v-for="card in cardGroup"
      :class="[{ [card.size]: true }, cardStyle]"
      :key="card.id"
    >
      <house-card v-bind="card" :type="cardStyle" />
    </li>
  </ul>
</template>

<script>
import CardGroup from '~/components/card-group'
import HouseCard from '../card'

export default {
  name: 'CardsGroup',
  components: {
    HouseCard
  },
  mixins: [CardGroup]
}
</script>
